import { ApolloError } from '@apollo/client'

/**
 * True when every error belongs to a field below a root field, so the query
 * still returned its root data (`errorPolicy: 'all'`). Network errors and
 * failed root fields are full failures.
 */
export const isPartialFailure = ({
  graphQLErrors,
  networkError
}: ApolloError) =>
  !networkError &&
  graphQLErrors.length > 0 &&
  graphQLErrors.every(({ path }) => (path?.length ?? 0) > 1)
